<xemex-dialog-shell
  [title]="(isEdit ? 'locations.updateDialog.title' : 'locations.addDialog.title') | translate"
>
  <form [formGroup]="addForm" class="location-dialog__form">
    @if (!isEdit && requiresPartnerSelection()) {
      <div>
        <xemex-partner-select
          [formControl]="partnerControl"
          [label]="'locations.addDialog.partnerLabel' | translate"
          [placeholder]="'locations.addDialog.partnerPlaceholder' | translate"
        />
        @if (partnerError()) {
          <span class="location-dialog__error">
            {{ 'locations.addDialog.noPartner' | translate }}
          </span>
        }
      </div>
    }

    <xemex-select-field [label]="'creation.step1.country' | translate" [required]="true">
      <lib-country-list
        [selectedCountryCode]="selectedCountry"
        [selectedCountryConfig]="countryConfig"
        [countryListConfig]="countryConfig"
        (onCountryChange)="onCountryChange($event)"
      ></lib-country-list>
    </xemex-select-field>

    <xemex-text-field
      formControlName="street"
      [label]="'creation.step1.streetName' | translate"
      [placeholder]="'e.g. Coolsingel'"
      [required]="true"
      [invalid]="addForm.controls['street'].invalid && addForm.controls['street'].touched"
      [errorText]="
        'error.required' | translate: { field: ('creation.step1.streetName' | translate) }
      "
    />

    <div class="location-dialog__grid">
      <xemex-text-field
        formControlName="street_number"
        [label]="'creation.step1.houseNumber' | translate"
        [placeholder]="'75'"
        [required]="true"
        [inputMode]="'numeric'"
        [invalid]="
          addForm.controls['street_number'].invalid && addForm.controls['street_number'].touched
        "
        [errorText]="
          addForm.controls['street_number'].errors?.['pattern']
            ? ('locations.addDialog.houseNumberInvalid' | translate)
            : ('error.required' | translate: { field: ('creation.step1.houseNumber' | translate) })
        "
      />

      <xemex-text-field
        formControlName="street_number_addition"
        [label]="'locations.addDialog.addition' | translate"
        [placeholder]="'A, bis, ...'"
      />
    </div>

    <div class="location-dialog__grid">
      <xemex-text-field
        formControlName="postalcode"
        [label]="'creation.step1.zipcode' | translate"
        [placeholder]="'1234 AB'"
        [required]="true"
        [invalid]="addForm.controls['postalcode'].invalid && addForm.controls['postalcode'].touched"
        [errorText]="
          'error.required' | translate: { field: ('creation.step1.zipcode' | translate) }
        "
      />

      <xemex-text-field
        formControlName="city"
        [label]="'creation.step1.city' | translate"
        [placeholder]="'e.g. Rotterdam'"
        [required]="true"
        [invalid]="addForm.controls['city'].invalid && addForm.controls['city'].touched"
        [errorText]="'error.required' | translate: { field: ('creation.step1.city' | translate) }"
      />
    </div>

    @if (!isEdit && canManageInstallationGroups()) {
      <xemex-select-field [label]="'locations.addDialog.installationGroupsLabel' | translate">
        <mat-select
          formControlName="installationGroupOids"
          multiple
          [placeholder]="'locations.addDialog.installationGroupsPlaceholder' | translate"
        >
          @for (group of installationGroups(); track group.installationGroupOid) {
            <mat-option [value]="group.installationGroupOid">{{ group.name }}</mat-option>
          }
        </mat-select>
      </xemex-select-field>
    }

    @if (saveError()) {
      <span class="location-dialog__error">
        {{
          (saveError() === 'retry'
            ? 'locations.addDialog.saveError'
            : 'locations.addDialog.saveErrorInvalid'
          ) | translate
        }}
      </span>
    }
  </form>

  <div actions class="location-dialog__actions">
    <xemex-text-button type="button" intent="primary" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>

    <div class="location-dialog__action-group">
      @if (!isEdit && !returnsCreated) {
        <xemex-tonal-button
          type="button"
          [loading]="isSaving"
          [disabled]="requiresPartnerSelection() && !selectedPartnerOid()"
          (click)="onSave(true)"
        >
          {{ 'locations.addDialog.saveAndAddAnother' | translate }}
        </xemex-tonal-button>
      }
      <xemex-filled-button
        type="button"
        [loading]="isSaving"
        [disabled]="!isEdit && requiresPartnerSelection() && !selectedPartnerOid()"
        (click)="onSave(false)"
      >
        {{ (isEdit ? 'general.btnSaveChanges' : 'locations.addDialog.btnSave') | translate }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
